import React from "react";
import ConfirmModal from "server/components/Modals/ConfirmModal";
import { Button, useNotify, useRefresh } from "react-admin";
import AssignmentIcon from "@mui/icons-material/Assignment";
import dataProvider from "server/dataProvider";
import { specialistRequests } from "api/specialistApi";
import { SpecialistStatuses } from "utils/constants";

const AssignExamCommitionDialog = ({ specialistId }) => {
  const notify = useNotify();
  const refresh = useRefresh();

  const handleSubmit = async () => {
    const payload = {
      TargetStatusId: SpecialistStatuses.Graduating,
    };
    await dataProvider.customRequest(
      specialistRequests.changeSpecialistStatus(specialistId),
      payload,
      "PATCH",
      undefined,
      true,
    );
    refresh();
    notify("Успешно назначаване на изпитна комисия на случаен принцип", { type: "success" });
  };

  return (
    <ConfirmModal
      titleContent={"Назначаване на изпитна комисия"}
      onConfirm={handleSubmit}
      triggerButton={
        <Button
          label="Назначи изпитна комисия"
          variant="contained"
          size="medium"
          startIcon={<AssignmentIcon />}
        />
      }
      message="Назначете изпитна комисия за специализанта на случаен принцип?"
    />
  );
};

export default AssignExamCommitionDialog;
